import FormBuilderConfig from "../../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import ITextBuilder from "../../../../../toolkit/baseForms2/iTextBuilder/ITextBuilder";
import {
  formatNumber,
  formatPercent,
  formatMoney
} from "../../../../helpers/formatters";
import { userHasPermission } from "../../../../../utils/accessTree";
import permissionCodes from "../../../../../utils/permissionCodes";

const {
  TRACKING_VENTAS_MEMBRESIA_EDICION_COMPROMISOS_ASESORES: EDICION_COMPROMISOS_ASESORES
} = permissionCodes;

export type Inputs =
  | "consolidado"
  | "consolidadoActual"
  | "consolidadoAlcance"
  | "totalVentas"
  | "totalVentasActual"
  | "totalVentasAlcance"
  | "numeroProspectos"
  | "numeroProspectosActual"
  | "numeroProspectosAlcance";

export type Buttons = never;

export const formConfigMapper: (
  periodoAnterior
) => FormBuilderConfig<Inputs, Buttons> = periodoAnterior => ({
  inputs: [
    {
      name: "consolidado",
      label: "",
      component: ITextBuilder,
      props: {
        type: "NUMERIC",
        cellCollapsed: true,
        cellFormatter: value => formatNumber(Number(value)),
        disabled:
          periodoAnterior || !userHasPermission(EDICION_COMPROMISOS_ASESORES)
      }
    },
    {
      name: "consolidadoActual",
      label: "",
      component: ITextBuilder,
      props: {
        type: "NUMERIC",
        cellCollapsed: true,
        cellFormatter: value => formatNumber(Number(value)),
        disabled: true
      }
    },
    {
      name: "consolidadoAlcance",
      label: "",
      component: ITextBuilder,
      props: {
        type: "NUMERIC",
        cellCollapsed: true,
        cellFormatter: value => formatPercent(Number(value)),
        disabled: true
      }
    },
    {
      name: "totalVentas",
      label: "",
      component: ITextBuilder,
      props: {
        type: "NUMERIC",
        cellCollapsed: true,
        cellFormatter: value => formatMoney(Number(value)),
        disabled:
          periodoAnterior || !userHasPermission(EDICION_COMPROMISOS_ASESORES)
      }
    },
    {
      name: "totalVentasActual",
      label: "",
      component: ITextBuilder,
      props: {
        type: "NUMERIC",
        cellCollapsed: true,
        cellFormatter: value => formatMoney(Number(value)),
        disabled: true
      }
    },
    {
      name: "totalVentasAlcance",
      label: "",
      component: ITextBuilder,
      props: {
        type: "NUMERIC",
        cellCollapsed: true,
        cellFormatter: value => formatPercent(Number(value)),
        disabled: true
      }
    },
    {
      name: "numeroProspectos",
      label: "",
      component: ITextBuilder,
      props: {
        type: "NUMERIC",
        cellCollapsed: true,
        cellFormatter: value => formatNumber(Number(value)),
        disabled:
          periodoAnterior || !userHasPermission(EDICION_COMPROMISOS_ASESORES)
      }
    },
    {
      name: "numeroProspectosActual",
      label: "",
      component: ITextBuilder,
      props: {
        type: "NUMERIC",
        cellCollapsed: true,
        cellFormatter: value => formatNumber(Number(value)),
        disabled: true
      }
    },
    {
      name: "numeroProspectosAlcance",
      label: "",
      component: ITextBuilder,
      props: {
        type: "NUMERIC",
        cellCollapsed: true,
        cellFormatter: value => formatPercent(Number(value)),
        disabled: true
      }
    }
  ],
  buttons: [],
  validations: {
    consolidado: {
      minNumber: {
        validator: value => value && Number(value) < 0,
        message: () => "Debe ser mayor o igual a 0"
      }
    },
    numeroProspectos: {
      minNumber: {
        validator: value => value && Number(value) < 0,
        message: () => "Debe ser mayor o igual a 0"
      }
    }
  },
  rows: [
    [
      "consolidado",
      "consolidadoActual",
      "consolidadoAlcance",
      "totalVentas",
      "totalVentasActual",
      "totalVentasAlcance",
      "numeroProspectos",
      "numeroProspectosActual",
      "numeroProspectosAlcance"
    ]
  ]
});
